import { render, staticRenderFns } from "./SingleInputMoney.vue?vue&type=template&id=3db124c6&scoped=true"
import script from "./SingleInputMoney.vue?vue&type=script&setup=true&lang=ts"
export * from "./SingleInputMoney.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SingleInputMoney.vue?vue&type=style&index=0&id=3db124c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db124c6",
  null
  
)

export default component.exports